// Library Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// Local Imports
import endPoints from '@/redux/constant';
import axios from '@/redux/http';
import { PURGE } from 'redux-persist';

// Initial State
const initialState = {
  statesLoading: false,
  citiesLoading: false,
  countriesLoading: false,
  error: null,
  cities: [],
  states: [],
  countries: []
};

// Fetch Countries API Fn
export const countriesAPIFn = createAsyncThunk(
  'countryFunction',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${endPoints.fetchCountries}?callingUserID=${values?.userId}`, {
        ...values,
      });

      const newData = data?.value?.map((country, index) => ({
        id: index + 1,
        countryId: country?.CountryID_ids,
        countryCode: country?.CountryCode_chr,
        name: country?.CountryName_chr
      }))
      return newData;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// Fetch States API Fn
export const statesAPIFn = createAsyncThunk(
  'stateFunction',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${endPoints.fetchStates}?country=${values?.country}`, {
        ...values,
      });
      const newData = data?.result?.data?.states?.map((state, index) => ({
        id: index + 1,
        stateCode: state?.state_code,
        name: state?.name
      }))
      return newData;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);


// Fetch States API Fn
export const citiesAPIFn = createAsyncThunk(
  'citiesFunction',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${endPoints.fetchCities}?callingUserID=${values?.userId}&country=${values?.country}`, {
        ...values,
      });
      const newData = data?.result?.map((state, index) => ({
        id: index + 1,
        name: state
      }))
      return newData;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);


// Login User Slices
export const statesAndCountriesSlice = createSlice({
  name: 'countries/statesSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(statesAPIFn.pending, (state) => {
        state.statesLoading = true;
        state.error = null;
      })
      .addCase(statesAPIFn.fulfilled, (state, action) => {
        state.statesLoading = false;
        state.states = action.payload;
        state.error = null;
      })
      .addCase(statesAPIFn.rejected, (state, action) => {
        state.statesLoading = false;
        state.error = action.payload;
      })
      .addCase(citiesAPIFn.pending, (state) => {
        state.citiesLoading = true;
        state.error = null;
      })
      .addCase(citiesAPIFn.fulfilled, (state, action) => {
        state.citiesLoading = false;
        state.cities = action.payload;
        state.error = null;
      })
      .addCase(citiesAPIFn.rejected, (state, action) => {
        state.citiesLoading = false;
        state.error = action.payload;
      })
      .addCase(countriesAPIFn.pending, (state) => {
        state.countriesLoading = true;
        state.error = null;
      })
      .addCase(countriesAPIFn.fulfilled, (state, action) => {
        state.countriesLoading = false;
        state.countries = action.payload;
        state.error = null;
      })
      .addCase(countriesAPIFn.rejected, (state, action) => {
        state.countriesLoading = false;
        state.error = action.payload;
        state.countries = [];
      })
      .addCase(PURGE, (state) => {
        state.statesLoading = false;
        state.countriesLoading = false;
        state.error = null;
        state.states = [];
        state.countries = []
      });
  },
});

export default statesAndCountriesSlice.reducer;